import { render, staticRenderFns } from "./ProductMargin.vue?vue&type=template&id=a95a6ff8&scoped=true&"
import script from "./ProductMargin.vue?vue&type=script&lang=ts&"
export * from "./ProductMargin.vue?vue&type=script&lang=ts&"
import style0 from "./ProductMargin.vue?vue&type=style&index=0&id=a95a6ff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95a6ff8",
  null
  
)

export default component.exports